import React, { useState } from 'react';
import { createUserWithEmailAndPassword, signOut } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import '../../stylesheets/HomePage.css';
import MKlogo from '../../img/Icons/MarketZLogo.png';
import Login from './Login';
import { useAuth } from '../../AuthContext';

const SuccessMessage = ({ onYes, onNo }) => {
  return (
    <div className="success-popup">
      <p>¡Cuenta creada con éxito! ¿Quieres iniciar sesión?</p>
      <div className="success-buttons">
        <button onClick={onYes}>Sí</button>
        <button onClick={onNo}>No</button>
      </div>
    </div>
  );
};

const Register = ({ onClose }) => {
  const { setUser } = useAuth();
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [error, setError] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [showLogin, setShowLogin] = useState(false);

  const registerUser = async (username, email, password, phone) => {
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      await setDoc(doc(db, 'users', user.uid), {
        uid: user.uid,
        username: username,
        email: user.email,
        phone: phone,
        purchases: [],
        shoppingCart: []
      });
      await signOut(auth);

      setIsSuccess(true);
    } catch (error) {
      console.error('Error al crear la cuenta:', error.message);
      if (error.code === 'auth/email-already-in-use') {
        setError('Este correo ya está en uso. Por favor, utiliza otro.');
      } else {
        setError('Hubo un error en el registro. Por favor, intenta nuevamente.');
      }
    }
  };

  const handleRegister = (e) => {
    e.preventDefault();
    if (username && email && password && phone) {
      if (password !== confirmPassword) {
        setError('Las contraseñas no coinciden.');
        return;
      }
      setError('');
      registerUser(username, email, password, phone);
    } else {
      setError('Todos los campos son obligatorios.');
    }
  };

  const handleYes = () => {
    setIsSuccess(false);
    setShowLogin(true);
  };

  const handleNo = () => {
    setIsSuccess(false);
    onClose();
  };

  return (
    <>
      {isSuccess && (
        <div className="success-message-container">
          <SuccessMessage onYes={handleYes} onNo={handleNo} />
        </div>
      )}
      {!isSuccess && !showLogin && (
        <div className='Login-Form-Cont'>
          <div className='Log-container'>
            <img src={MKlogo} alt='' className='MKZ-Icon-re' />
            <h1>¿Aún no tienes cuenta?, ¡Regístrate ahora!</h1>
          </div>
          <form className='login-form' onSubmit={handleRegister}>
            <div className='field-container'>
              <div className='txt-container'>
                <h2 className='field-txt'>Nombre de Usuario</h2>
              </div>
              <div className='input-container'>
                <input
                  type='text'
                  className='input'
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className='field-container'>
              <div className='txt-container'>
                <h2 className='field-txt'>Correo Electrónico</h2>
              </div>
              <div className='input-container'>
                <input
                  type='email'
                  className='input'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className='field-container'>
              <div className='txt-container'>
                <h2 className='field-txt'>Número de Teléfono</h2>
              </div>
              <div className='input-container'>
                <input
                  type='text'
                  className='input'
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className='field-container'>
              <div className='txt-container'>
                <h2 className='field-txt'>Contraseña</h2>
              </div>
              <div className='input-container'>
                <input
                  type='password'
                  className='input'
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className='field-container'>
              <div className='txt-container'>
                <h2 className='field-txt'>Confirmar Contraseña</h2>
              </div>
              <div className='input-container'>
                <input
                  type='password'
                  className='input'
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
              </div>
            </div>
            {error && <p className='error-message'>{error}</p>}
            <button type='submit' className='login-btn'>Crear cuenta</button>
          </form>
        </div>
      )}
      {showLogin && <Login onClose={onClose} />}
    </>
  );
};

export default Register;
